import { render, staticRenderFns } from "./CreateManufacturingLogbook.vue?vue&type=template&id=3d51ff4c"
import script from "./CreateManufacturingLogbook.vue?vue&type=script&lang=js"
export * from "./CreateManufacturingLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports